module.exports = __webpack_public_path__ + "static/conflict_card_img2@2x-1c8a92620b6d771b406f3ce285291739.jpg";